export default function applyHttpsImage(url?: string) {
  return (url || '').replace?.('http://', '//')
}
